let Course = Backbone.Model.extend(
    {
        defaults:
            {
                identifier: null,
                guid: null,
                shareGuid: null,
                name: null,
                hours: 0,
                link: null,
                years: null,
                min_credit_points: 0,
                contact_number: null,
                unit_group_requirements: null,
                group_name: null,
                level_no: null,
                grad_help_text: null,
                course_duration_note: null,
                course_duration_note_years: null,
                hide_unit_codes: false,
                allow_new_students: true,
            },

        initialize: function() {
            if(this.getGuid() === null) {
                this.set('guid', newGuid());
            }
            if(this.getShareGuid() === null) {
                this.set('shareGuide', newGuid());
            }
        },

        getIdentifier: function () {
            return this.get('identifier');
        },

        getGuid() {
            return this.get('guid');
        },

        getShareGuid() {
            return this.get('shareGuid');
        },

        getYears: function () {
            return this.get('years');
        },
        getLink: function () {
            return this.get('link');
        },
        getName: function () {
            return this.get('name');
        },
        getHours: function () {
            return this.get('hours');
        },
        getMinCreditPoints: function () {
            return this.get('min_credit_points');
        },
        getContactNumber: function () {
            return this.get('contact_number');
        },
        setContactNumber: function (contactNumber) {
            this.set('contact_number', contactNumber);
        },
        getGroupRequirements: function () {
            return this.get('unit_group_requirements');
        },
        getGroupName: function () {
            return this.get('group_name');
        },
        getGradHelpText: function () {
            return this.get('grad_help_text')
        },
        getCourseDurationNote: function () {
            return this.get('course_duration_note')
        },
        getCourseDurationNoteYears: function () {
            return this.get('course_duration_note_years')
        },
        allowNewStudents: function () {
            return this.get('allow_new_students')
        },
        hideUnitCodes: function () {
            return this.get('hide_unit_codes')
        },
        getElectivesTermName: function() {
            return null;
        }
    }
);


let CourseList = Backbone.Collection.extend(
    {
        model: Course

    }
);
